(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pinata-sdk", [], factory);
	else if(typeof exports === 'object')
		exports["pinata-sdk"] = factory();
	else
		root["pinata-sdk"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 